import { enums } from "@shared/constants";
import NumericFormat from "../../form/NumericFormat/NumericFormat.web";
import type { CurrencyFormatSharedProps } from "./CurrencyFormat.props";
import {
  getDecimalSeparator,
  getPrefix,
  getSuffix,
  getThousandSeparator,
} from "./CurrencyFormat.utils";

export type CurrencyFormatProps = CurrencyFormatSharedProps & {
  // Add any web specific props here.
};

/**
 * Displays pricing.
 *
 * This component deals with a single element in pricing: a total, line item, a service fee etc.
 *
 * For all in pricing, see AllInPricing.
 */
export default function CurrencyFormat({
  inputRef,
  currency = enums.CURRENCY_MAP.CAD.id,
  includeSuffix = false,
  accountingFormat = false,
  value,
  autoDecimalScale,
  decimalScale,
  ...props
}: CurrencyFormatProps) {
  return (
    <NumericFormat
      {...props}
      value={value}
      getInputRef={inputRef}
      thousandSeparator={getThousandSeparator(value)}
      decimalSeparator={getDecimalSeparator()}
      decimalScale={autoDecimalScale ? undefined : decimalScale ?? 2}
      fixedDecimalScale
      prefix={getPrefix(currency, accountingFormat, value)}
      suffix={getSuffix(currency, accountingFormat, value, includeSuffix)}
      allowNegative={!accountingFormat}
      autoComplete={props.displayType === "input" ? "off" : undefined}
    />
  );
}
